module.exports = __webpack_public_path__ + "static/media/vegitables_0.39797473.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_0.csv
// module id = 590
// module chunks = 0